import React from "react";
import HeroCarouselDesktop from "./HeroCarouselDesktop";
import { ComponentProps, CheckboxField } from "../../types/types";
import {
  HeroCarouselFields,
  TextColorField,
  TextColorSitecoreField,
} from "./types";
import fieldsMock from "./NotEditableFieldsMock";
import "./style.scss";
import LazySection from "../../react-only-components/LazySection";

interface HeroCarouselProps extends ComponentProps<HeroCarouselFields, {}> {}

const colorMapper: (sitecoreColor: TextColorSitecoreField) => TextColorField = (
  sitecoreColor
) => sitecoreColor?.fields?.Key;

const fieldMapper: (sitecoreFields: HeroCarouselFields) => {
  items: any[];
  showCarouselOverlay: CheckboxField;
} = (sitecoreFields) => {
  const sitecoreItems = sitecoreFields["Carousel Slides"];
  const showCarouselOverlay = sitecoreFields["Show Carousel Overlay"];
  const items = sitecoreItems.map(({ fields }) => {
    return {
      image: fields?.Image,
      imageMobile: fields?.imageMobile,
      title: fields?.Title,
      content: fields?.Content,
      link: fields?.Link,
      textColor: fields && colorMapper(fields["Text Color"]),
      video: fields?.Video,
      useVideo: fields?.["Use Video"],
      eyebrow: fields?.["Eyebrow"],
    };
  });

  return {
    items,
    showCarouselOverlay,
  };
};

const HeroCarousel = (props: HeroCarouselProps) => {
  let fields: HeroCarouselFields;

  if (!props.fields || !Object.keys(props.fields).length) {
    fields = fieldsMock;
  } else {
    fields = props.fields;
  }

  const mappedFields = fieldMapper(fields);
  const { items, showCarouselOverlay } = mappedFields;
  const params: any = props.params;

  return (
    <LazySection offset={-200} id={props?.rendering?.uid}>
      {props.fields && (
        <section className={"carousel-wrapper hero-carousel"}>
          <HeroCarouselDesktop
            items={items}
            params={params?.Variation}
            showCarouselOverlay={showCarouselOverlay}
            carousalType={params?.CarouselType}
          />
        </section>
      )}
    </LazySection>
  );
};

export default HeroCarousel;
